var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loaded
      ? _c("div", { staticClass: "form-row" }, [
          !_vm.readonly
            ? _c(
                "div",
                { staticClass: "col form-group input-group" },
                [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c(
                      "div",
                      { staticClass: "input-group-text" },
                      [
                        _c("ItpIcon", {
                          attrs: { icon: "material-symbols:calendar-month" }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("ItpFormSelect", {
                    attrs: {
                      name: "selectedRuleID",
                      options: _vm.rules,
                      valueField: "id",
                      textField: "rule.description",
                      placeholder: _vm._f("pgettext")(
                        "Select predefined rule to add.",
                        "BillingDateRule"
                      )
                    },
                    model: {
                      value: _vm.selectedRuleID,
                      callback: function($$v) {
                        _vm.selectedRuleID = $$v
                      },
                      expression: "selectedRuleID"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-group-append" },
                    [
                      _c("ItpButton", {
                        attrs: {
                          variant: "light",
                          icon: "fa-plus",
                          tooltip: _vm._f("pgettext")(
                            "Add rule configuration",
                            "BillingDateRule"
                          ),
                          disabled: !_vm.selectedRuleID
                        },
                        on: {
                          click: function($event) {
                            return _vm.evh_4207795475682514_click($event, {})
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.loaded
      ? _c("div", { staticClass: "form-row" }, [
          _c(
            "div",
            { staticClass: "form-group col-md-8" },
            [
              _c("ItpFormSelect", {
                attrs: {
                  name: "anchor",
                  options: _vm.anchorOptions,
                  valueField: "value",
                  textField: "name",
                  required: "",
                  readonly: _vm.readonly
                },
                model: {
                  value: _vm.item.anchor,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "anchor", $$v)
                  },
                  expression: "item.anchor"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group col-md-4" }, [
            _c(
              "div",
              { staticClass: "input-group" },
              [
                _c("div", { staticClass: "input-group-prepend" }, [
                  _c("div", { staticClass: "input-group-text" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.isOffsetDaysSet,
                          expression: "isOffsetDaysSet"
                        }
                      ],
                      attrs: { type: "checkbox", readonly: _vm.readonly },
                      domProps: {
                        checked: Array.isArray(_vm.isOffsetDaysSet)
                          ? _vm._i(_vm.isOffsetDaysSet, null) > -1
                          : _vm.isOffsetDaysSet
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.isOffsetDaysSet,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.isOffsetDaysSet = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.isOffsetDaysSet = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.isOffsetDaysSet = $$c
                            }
                          },
                          function($event) {
                            return _vm.evh_6217772979034815_change($event, {})
                          }
                        ]
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("ItpFormInput", {
                  ref: "offsetDays",
                  attrs: {
                    type: "number",
                    name: "offset_days",
                    disabled: !_vm.isOffsetDaysSet,
                    readonly: _vm.readonly
                  },
                  model: {
                    value: _vm.item.offset_days,
                    callback: function($$v) {
                      _vm.$set(_vm.item, "offset_days", $$v)
                    },
                    expression: "item.offset_days"
                  }
                }),
                _vm._v(" "),
                _c("DIV", { staticClass: "input-group-append" }, [
                  _c("span", { staticClass: "input-group-text" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm._f("pgettext")("day", "InputGroupAddon")) +
                        "\n          "
                    )
                  ])
                ])
              ],
              1
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.loaded
      ? _c("div", { staticClass: "form-row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _vm.loaded
                ? _c("ItpFormInput", {
                    attrs: {
                      name: "description",
                      placeholder: _vm._f("pgettext")(
                        "Rule description",
                        "BillingDateRule"
                      ),
                      readonly: _vm.readonly
                    },
                    model: {
                      value: _vm.item.description,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "description", $$v)
                      },
                      expression: "item.description"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }